interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const SHORTCUTS: Array<[string, string]> = [
  ['N', 'Criar novo nó no centro da viewport'],
  ['Enter', 'Editar label do nó selecionado (inline)'],
  ['Tab / Shift+Tab', 'Selecionar próximo / anterior nó'],
  ['F', 'Centralizar grafo (zoom-to-fit)'],
  ['Ctrl/Cmd + Z', 'Desfazer'],
  ['Ctrl/Cmd + Y', 'Refazer'],
  ['Delete', 'Apagar nó(s) selecionado(s)'],
  ['Esc', 'Limpar seleção / cancelar link'],
  ['Shift + arrastar nó', 'Iniciar conexão (link)'],
  ['Handle ⊕ no nó', 'Iniciar conexão pelo handle'],
  ['Arrastar link → vazio', 'Criar nó e conectar'],
  ['Duplo clique no nó', 'Entrar no universo'],
  ['Ctrl/Cmd + click', 'Multi-seleção'],
  ['Botão direito', 'Menu de contexto (nó / link / canvas)'],
  ['Ctrl/Cmd + K', 'Paleta de comandos'],
  ['Alt + G', 'Toggle snap-to-grid'],
  ['Scroll', 'Zoom (mouse-anchored)'],
  ['Arrastar canvas', 'Mover câmera'],
  ['?', 'Atalhos (este painel)'],
];

export function ShortcutsModal({ isOpen, onClose }: Props) {
  if (!isOpen) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)',
        display: 'grid', placeItems: 'center', zIndex: 300,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="glass-panel"
        style={{ borderRadius: 14, padding: 24, width: 520, maxWidth: '90vw' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600 }}>Atalhos</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>
            ✕
          </button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '8px 24px', fontSize: 13 }}>
          {SHORTCUTS.map(([key, desc]) => (
            <span key={key} style={{ display: 'contents' }}>
              <code style={{
                fontFamily: 'var(--font-mono)',
                background: 'rgba(255,255,255,0.06)',
                padding: '2px 8px', borderRadius: 4,
                color: 'var(--neon)', whiteSpace: 'nowrap',
              }}>
                {key}
              </code>
              <span style={{ color: 'var(--muted)' }}>{desc}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
